<template>
  <div class="form-group col-lg-4">
    <label for="capacity" class="font-weight-bold text-dark text-2">{{ trans('Cylinder Capacity') }}</label>
    <div class="row">
      <div class="col-6">
        <input id="capacity"
               type="text"
               placeholder="1498"
               :value="value"
               @input="unitUpdateHandler"
               @change="unitUpdateHandler"
               :disabled="disabled"
               class="form-control"
        >
      </div>
      <div class="col-6 pl-0">
        <v-select :value="unit"
                  @input="val => this.$emit('unitChange', val)"
                  placeholder="cc"
                  :disabled="disabled"
                  :clearable="false"
                  :reduce="option => option.value"
                  :options="[
                    { value: 'cc', label: 'cc' },
                    { value: 'l', label: 'L' }
                  ]"
        />
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "CapacityInput",

    props: {
      value: {
        type: [Number, String],
        default: '',
      },
      unit: {
        type: String,
        default: 'cc',
      },
      disabled: {
        type: Boolean,
        default: false,
      }
    },

    data() {
      return {
        id: null,
        unitAuto: null,
      }
    },

    mounted() {
      this.id = this.$options.name + this._uid;
    },

    computed: {
      valueCc() {
        const unit = this.unit || 'l';
        return unit === 'l' ?
          Math.round(parseFloat(this.value) * 1000) :
          Math.round(parseFloat(this.value));
      },
    },

    methods: {
      unitUpdateHandler(event) {
        const val = event.target.value;

        const re = /(?<val>[\d,.]+?)(?<unit>[\sa-z]+)/gi;
        const reLeadingLetters = /^\D+/g;
        const result = re.exec(String(val).replace(reLeadingLetters, ''));
        let value;

        if (result) {
          const inputUnit = result.groups.unit.trim().toLowerCase();
          const inputValue = result.groups.val.trim();

          if (inputUnit === 'l') {
            this.unit = 'l';
            this.$emit('unitChange', 'l');
          } else if (inputUnit) {
            this.unit = 'cc';
            this.$emit('unitChange', 'cc');
          }

          value = inputValue.replace(',', '.');
        } else {
          value = String(val).replace(',', '.');
        }

        this.$emit('input', value);
      },
    },

    watch: {
      valueCc(val) {
        this.$emit('ccValueChange', val);
      },
    },
  }
</script>
